import { FunctionComponent } from "react";

import { useComponentConfig } from "@ui/context/component-config-context";
import useDefaults from "@ui/hooks/use-defaults";

import * as styles from "./ContentCardScore.css";

export interface ContentCardScoreBaseConfig {
  scoreLabel?: string | null;
}

interface Props extends ContentCardScoreBaseConfig {
  score: number;
}

const ContentCardScore: FunctionComponent<Props> = ({ score, ...props }) => {
  const contentCardScoreConfig = useComponentConfig("contentCardScore", "");
  const { scoreLabel } = useDefaults(props, contentCardScoreConfig);
  return (
    <div className={styles.scoreContainer}>
      <p className={styles.score}>{score}</p>
      <p className={styles.scoreLabel}>{scoreLabel}</p>
    </div>
  );
};

export default ContentCardScore;
